import { render, staticRenderFns } from "./GoalsView.vue?vue&type=template&id=7ac54a58&scoped=true"
import script from "./GoalsView.vue?vue&type=script&lang=js"
export * from "./GoalsView.vue?vue&type=script&lang=js"
import style0 from "./GoalsView.vue?vue&type=style&index=0&id=7ac54a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac54a58",
  null
  
)

export default component.exports